module.exports = __webpack_public_path__ + "static/img/default.1fcdf2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/default.png
// module id = f4JG
// module chunks = 1